<div [formGroup]="form" class="detail-right-column">
   @if (showCards) {
   <ndt-card [title]="'General Information'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="generalInfoFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half">
      <mat-label>Extension Number</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extension?.number"
         [formControl]="parentFormGroup.get('number')"
         required
         id="a548a982-17d2-4bee-9fa9-e2df166087e7"
      />
      @if (parentFormGroup.get('number')?.hasError('required')) {
      <mat-error> Number Field is Required. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('pattern')) {
      <mat-error> Invalid Number Format </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
      <mat-error> Number must be between 100-99999. </mat-error>
      } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
      <mat-error> Extension number already in use. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.name"
         [formControl]="parentFormGroup.get('name')"
         required
         id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
      />
      @if (parentFormGroup.get('name')?.hasError('required')) {
      <mat-error> Name Field is Required. </mat-error>
      } @if ( !parentFormGroup.get('name')?.hasError('required') && parentFormGroup.get('name')?.hasError('noContent') )
      {
      <mat-error> Name must contain characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half">
      <mat-label>Short Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extension?.shortName"
         [formControl]="parentFormGroup.get('shortName')"
         id="ead89d99-49d9-448e-9743-6d44e13bb801"
      />
      @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
      <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
      }
   </mat-form-field>
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Display Name</mat-label>
      <input
         matInput
         autocomplete="off"
         type="text"
         [value]="extensionHuntGroup?.displayName"
         formControlName="displayName"
         required
      />
      @if (form.get('displayName')?.hasError('required')) {
      <mat-error> Display Name is Required. </mat-error>
      } @if (!form.get('displayName')?.hasError('required') && form.get('displayName')?.hasError('noContent')) {
      <mat-error> Display Name must contain characters. </mat-error>
      }
   </mat-form-field>
   }
   <ng-template #generalInfoFields>
      <mat-form-field class="flex-half">
         <mat-label>Extension Number</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extension?.number"
            [formControl]="parentFormGroup.get('number')"
            required
            id="a548a982-17d2-4bee-9fa9-e2df166087e7"
         />
         @if (parentFormGroup.get('number')?.hasError('required')) {
         <mat-error> Number Field is Required. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('pattern')) {
         <mat-error> Invalid Number Format </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('min') || parentFormGroup.get('number')?.hasError('max')) {
         <mat-error> Number must be between 100-99999. </mat-error>
         } @if (parentFormGroup.get('number')?.hasError('extensionAlreadyExists')) {
         <mat-error> Extension number already in use. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.name"
            [formControl]="parentFormGroup.get('name')"
            required
            id="31ebd3f9-980e-4a68-b05d-0d3d768c2d4c"
         />
         @if (parentFormGroup.get('name')?.hasError('required')) {
         <mat-error> Name Field is Required. </mat-error>
         } @if ( !parentFormGroup.get('name')?.hasError('required') &&
         parentFormGroup.get('name')?.hasError('noContent') ) {
         <mat-error> Name must contain characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half">
         <mat-label>Short Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extension?.shortName"
            [formControl]="parentFormGroup.get('shortName')"
            id="ead89d99-49d9-448e-9743-6d44e13bb801"
         />
         @if (parentFormGroup.get('shortName')?.hasError('pattern')) {
         <mat-error> Short Name cannot be greater than 20 characters. </mat-error>
         }
      </mat-form-field>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Display Name</mat-label>
         <input
            matInput
            autocomplete="off"
            type="text"
            [value]="extensionHuntGroup?.displayName"
            formControlName="displayName"
            required
         />
         @if (form.get('displayName')?.hasError('required')) {
         <mat-error> Display Name is Required. </mat-error>
         } @if (!form.get('displayName')?.hasError('required') && form.get('displayName')?.hasError('noContent')) {
         <mat-error> Display Name must contain characters. </mat-error>
         }
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Notes'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="notesFields"></ng-container>
   </ndt-card>
   }
   <ng-template #notesFields>
      @if (isSystemUser) {
      <mat-form-field class="flex-half">
         <mat-label>Admin Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('adminNotes')"
            id="extension-phone-dnd-status"
         ></textarea>
      </mat-form-field>
      }
      <mat-form-field [ngClass]="{ 'flex-full': !isSystemUser, 'flex-half': isSystemUser }">
         <mat-label>Extension Notes</mat-label>
         <textarea
            matInput
            [formControl]="parentFormGroup.get('extensionNotes')"
            id="extension-phone-dnd-status"
            [readonly]="isSystemUser"
         ></textarea>
      </mat-form-field>
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Settings'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="settingFields"></ng-container>
   </ndt-card>
   } @else {
   <div class="flex-full">
      <ndt-extension-and-group-chip-input
         [extensions]="extension?.account?.extensionsConnection?.items || extensions"
         [extensionGroups]="extension?.account?.extensionGroupsConnection?.items || extensionGroups"
         formControlName="extensionsOrExtensionGroupMembers"
         [extensionIdsToExclude]="extensionIdsToExclude"
         [extensionGroupIdsToExclude]="[]"
         required="true"
         [titleValue]="'Member Extensions'"
      ></ndt-extension-and-group-chip-input>
   </div>
   <mat-form-field class="flex-half">
      <mat-label>Ring Timeout</mat-label>
      <input
         matInput
         autocomplete="off"
         type="number"
         [value]="extensionHuntGroup?.ringTimeout"
         formControlName="ringTimeout"
         required
      />
      @if (form.get('ringTimeout')?.hasError('required')) {
      <mat-error> Ring Timeout Field is Required. </mat-error>
      } @if (form.get('ringTimeout')?.hasError('min') || form.get('ringTimeout')?.hasError('max')) {
      <mat-error> Number must be between 0-59. </mat-error>
      }
   </mat-form-field>
   @if (accountId) {
   <mat-form-field class="flex-half">
      <mat-label>Location</mat-label>
      <input
         autocomplete="off"
         type="text"
         [lcsSingleSelect]="locationSelect"
         ndtLocationSelect
         [accountId]="accountId"
         [formControl]="parentFormGroup.get('location')"
         id="location"
      />
      <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
   </mat-form-field>
   }
   <mat-form-field class="flex-half">
      <mat-label>Time Zone</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="timeZoneSelect"
         ndtTimeZoneSelect
         autocomplete="off"
         type="text"
         [formControl]="parentFormGroup.get('timeZone')"
         id="extension-phone-time-zone"
         [placeholder]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      />
      <ndt-time-zone-select
         #timeZoneSelect
         isIncludeEmptyOption="true"
         [overrideEmptyOption]="
            'Use Location/Account Time Zone - (' +
            (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
            ')'
         "
      ></ndt-time-zone-select>
   </mat-form-field>
   <mat-checkbox class="flex-full" [checked]="extensionHuntGroup?.callerIdOverride" formControlName="callerIdOverride"
      >Override caller ID with hunt group name</mat-checkbox
   >
   }
   <ng-template #settingFields>
      <div class="flex-full">
         <ndt-extension-and-group-chip-input
            [extensions]="extension?.account?.extensionsConnection?.items || extensions"
            [extensionGroups]="extension?.account?.extensionGroupsConnection?.items || extensionGroups"
            formControlName="extensionsOrExtensionGroupMembers"
            [extensionIdsToExclude]="extensionIdsToExclude"
            [extensionGroupIdsToExclude]="[]"
            required="true"
            [titleValue]="'Member Extensions'"
         ></ndt-extension-and-group-chip-input>
      </div>
      <mat-form-field class="flex-half">
         <mat-label>Ring Timeout</mat-label>
         <input
            matInput
            autocomplete="off"
            type="number"
            [value]="extensionHuntGroup?.ringTimeout"
            formControlName="ringTimeout"
            required
         />
         @if (form.get('ringTimeout')?.hasError('required')) {
         <mat-error> Ring Timeout Field is Required. </mat-error>
         } @if (form.get('ringTimeout')?.hasError('min') || form.get('ringTimeout')?.hasError('max')) {
         <mat-error> Number must be between 0-59. </mat-error>
         }
      </mat-form-field>
      @if (accountId) {
      <mat-form-field class="flex-half">
         <mat-label>Location</mat-label>
         <input
            autocomplete="off"
            type="text"
            [lcsSingleSelect]="locationSelect"
            ndtLocationSelect
            [accountId]="accountId"
            [formControl]="parentFormGroup.get('location')"
            id="location"
         />
         <ndt-location-select #locationSelect isIncludeEmptyOption="true"></ndt-location-select>
      </mat-form-field>
      }
      <mat-form-field class="flex-half">
         <mat-label>Time Zone</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="timeZoneSelect"
            ndtTimeZoneSelect
            autocomplete="off"
            type="text"
            [formControl]="parentFormGroup.get('timeZone')"
            id="extension-phone-time-zone"
            [placeholder]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         />
         <ndt-time-zone-select
            #timeZoneSelect
            isIncludeEmptyOption="true"
            [overrideEmptyOption]="
               'Use Location/Account Time Zone - (' +
               (parentFormGroup.get('location')?.value?.timeZoneId ?? extension?.account?.timeZoneId ?? timeZoneId) +
               ')'
            "
         ></ndt-time-zone-select>
      </mat-form-field>
      <mat-checkbox
         class="flex-full"
         [checked]="extensionHuntGroup?.callerIdOverride"
         formControlName="callerIdOverride"
         >Override caller ID with hunt group name</mat-checkbox
      >
   </ng-template>

   @if (showCards) {
   <ndt-card [title]="'Routing'" class="detail-card-half">
      <ng-container *ngTemplateOutlet="routingFields"></ng-container>
   </ndt-card>
   } @else {
   <mat-form-field class="flex-half field-padding-right">
      <mat-label>Route Busy Extension</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="routeBusyExtensionSelect"
         [accountId]="accountId"
         ndtExtensionSelect
         autocomplete="off"
         type="text"
         formControlName="routeBusyExtension"
         id="extension-hunt-group-route-busy-extension"
         [placeholder]="routeBusyPlaceholder"
         [extensionTypesToExclude]="[7]"
         (ngModelChange)="handleRouteBusyExtensionChange()"
      />
      <ndt-extension-select
         #routeBusyExtensionSelect
         [nullActionsToInclude]="nullActions"
         [excludedIds]="[extensionId]"
      ></ndt-extension-select>
   </mat-form-field>
   <mat-radio-group
      formControlName="isRouteBusyVoicemailOnly"
      class="flex-half radio-group"
      [style.visibility]="isRouteBusyExtensionTypePhone ? 'visible' : 'hidden'"
   >
      <div class="radio-container">
         <mat-radio-button class="table-radio-button" [value]="false" color="primary">Extension</mat-radio-button>
         <mat-radio-button class="table-radio-button" [value]="true" color="primary"> Voicemail </mat-radio-button>
      </div>
   </mat-radio-group>
   <mat-form-field class="flex-half">
      <mat-label>Route No Answer Extension</mat-label>
      <input
         class="empty-option-placeholder"
         [lcsSingleSelect]="routeNoAnswerExtensionSelect"
         [accountId]="accountId"
         ndtExtensionSelect
         autocomplete="off"
         type="text"
         formControlName="routeNoAnswerExtension"
         id="extension-hunt-group-route-no-answer-extension"
         [placeholder]="routeNoAnswerPlaceholder"
         [extensionTypesToExclude]="[7]"
         (ngModelChange)="handleRouteNoAnswerExtensionChange()"
      />
      <ndt-extension-select
         #routeNoAnswerExtensionSelect
         [nullActionsToInclude]="nullActions"
         [excludedIds]="[extensionId]"
      ></ndt-extension-select>
   </mat-form-field>
   <mat-radio-group
      formControlName="isRouteNoAnswerVoicemailOnly"
      class="flex-half radio-group"
      [style.visibility]="isRouteNoAnswerExtensionTypePhone ? 'visible' : 'hidden'"
   >
      <div class="radio-container">
         <mat-radio-button class="table-radio-button" [value]="false" color="primary">Extension</mat-radio-button>
         <mat-radio-button class="table-radio-button" [value]="true" color="primary"> Voicemail </mat-radio-button>
      </div>
   </mat-radio-group>
   }
   <ng-template #routingFields>
      <mat-form-field class="flex-half field-padding-right">
         <mat-label>Route Busy Extension</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="routeBusyExtensionSelect"
            [accountId]="accountId"
            ndtExtensionSelect
            autocomplete="off"
            type="text"
            formControlName="routeBusyExtension"
            id="extension-hunt-group-route-busy-extension"
            [placeholder]="routeBusyPlaceholder"
            [extensionTypesToExclude]="[7]"
            (ngModelChange)="handleRouteBusyExtensionChange()"
         />
         <ndt-extension-select
            #routeBusyExtensionSelect
            [nullActionsToInclude]="nullActions"
            [excludedIds]="[extensionId]"
         ></ndt-extension-select>
      </mat-form-field>
      <mat-radio-group
         formControlName="isRouteBusyVoicemailOnly"
         class="flex-half radio-group"
         [style.visibility]="isRouteBusyExtensionTypePhone ? 'visible' : 'hidden'"
      >
         <div class="radio-container">
            <mat-radio-button class="table-radio-button" [value]="false" color="primary">Extension</mat-radio-button>
            <mat-radio-button class="table-radio-button" [value]="true" color="primary"> Voicemail </mat-radio-button>
         </div>
      </mat-radio-group>
      <mat-form-field class="flex-half">
         <mat-label>Route No Answer Extension</mat-label>
         <input
            class="empty-option-placeholder"
            [lcsSingleSelect]="routeNoAnswerExtensionSelect"
            [accountId]="accountId"
            ndtExtensionSelect
            autocomplete="off"
            type="text"
            formControlName="routeNoAnswerExtension"
            id="extension-hunt-group-route-no-answer-extension"
            [placeholder]="routeNoAnswerPlaceholder"
            [extensionTypesToExclude]="[7]"
            (ngModelChange)="handleRouteNoAnswerExtensionChange()"
         />
         <ndt-extension-select
            #routeNoAnswerExtensionSelect
            [nullActionsToInclude]="nullActions"
            [excludedIds]="[extensionId]"
         ></ndt-extension-select>
      </mat-form-field>
      <mat-radio-group
         formControlName="isRouteNoAnswerVoicemailOnly"
         class="flex-half radio-group"
         [style.visibility]="isRouteNoAnswerExtensionTypePhone ? 'visible' : 'hidden'"
      >
         <div class="radio-container">
            <mat-radio-button class="table-radio-button" [value]="false" color="primary">Extension</mat-radio-button>
            <mat-radio-button class="table-radio-button" [value]="true" color="primary"> Voicemail </mat-radio-button>
         </div>
      </mat-radio-group>
   </ng-template>
</div>
